module.exports = __webpack_public_path__ + "static/dot-pattern-4ba98265d9e86ed2f3a83bf546338e1b.svg";